import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as IdCard } from '../../assets/images/svg/id-card.svg';
import themeColors from '../../assets/styles/themeColors';

const IdCardIconStyled = styled(IdCard)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const IdCardIcon = (props) => <IdCardIconStyled {...props} />;

IdCardIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

IdCardIcon.defaultProps = {
  w: '25px',
  h: '25px',
};

export default IdCardIcon;
